// @flow

import * as React from 'react';

import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
    
} from 'reactstrap';

import { HashLink as Link } from 'react-router-hash-link';

import { LinkContainer } from 'react-router-bootstrap';
import './NavMenu.css';
import type {CalculationRequestProjectResult} from "../common/RequestTypes";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import {actionCreators} from "../store/Calculation";
import type {ProjectUiInput} from "../store/Calculation";
import type {PhaseState} from "./CalculationPhaseInput";
import OptionManager from "../common/OptionManager";
import ReactAI from 'react-appinsights';
import config from "../common/Config";

type Props = {
    calcResult: CalculationRequestProjectResult,
    version: string,

    projectUiInput: ProjectUiInput,
    calcResult: ?CalculationRequestProjectResult,

    userAuths?: Array,
    personEmail?: ?string

}

type CalcDropDownProps = {
    hashLink: string, 
    label: string, 
    indent: boolean, 
    onClick: Function
}

type State = {
    navBarIsOpen: boolean,
    calcDropDownIsOpen: boolean
}

const CalcDropDownItem = (props: CalcDropDownProps) => {
    const indentEl = <span>&nbsp;&nbsp;&nbsp;</span>;
    return (<Link  
                  to={`${props.hashLink}`} 
                  className={ 'dropdown-item ' + (props.indent ? 'level-1' : 'level-0') }
                  scroll={el => el.scrollIntoView({block: "start", inline: "nearest", behavior: "smooth"})} 
                  onClick={props.onClick}>
        {props.indent && indentEl}{props.label}
    </Link>);
};

class NavMenu extends React.Component<Props, State> {
    
    optionManager: OptionManager;
    
    constructor(props: Props) {
        super(props);

        this.state = {
            navBarIsOpen: false,
            calcDropDownIsOpen: false
        };
        
        this.optionManager = new OptionManager();
    }

    toggleNavBar() {
        this.setState({
            navBarIsOpen: !this.state.navBarIsOpen
        });
    }
    
    toggleCalcDropDown() {
        this.setState({
            calcDropDownIsOpen: !this.state.calcDropDownIsOpen
        });
    }
    
    
    createPhaseNavs(phaseState: PhaseState, phaseNr: number, multiPhase: boolean) {
        let phaseNavs = [];
        
        let baseUrl = '/calculation#';

        let toggleDropDown = this.toggleCalcDropDown.bind(this);

        if(multiPhase)
            phaseNavs.push(<CalcDropDownItem hashLink={`${baseUrl}phase-${phaseNr}`} label={`Etapp ${phaseNr}`} indent={false} key={10} onClick={toggleDropDown} />);
        
        phaseNavs.push(<CalcDropDownItem hashLink={`${baseUrl}tech-choice-${phaseNr}`} label="Teknik" indent={multiPhase} key={20} onClick={toggleDropDown} />);
        if(phaseState.techniquesToCompare !== -1) {
            
            phaseNavs.push(<CalcDropDownItem hashLink={`${baseUrl}place-before-${phaseNr}`} label="Platsen före" indent={multiPhase} key={30} onClick={toggleDropDown} />);
            phaseNavs.push(<CalcDropDownItem hashLink={`${baseUrl}place-after-${phaseNr}`} label="Platsen efter" indent={multiPhase} key={40} onClick={toggleDropDown} />);
            phaseNavs.push(<CalcDropDownItem hashLink={`${baseUrl}distances-${phaseNr}`} label="Avstånd" indent={multiPhase} key={50} onClick={toggleDropDown} />);
            phaseNavs.push(<CalcDropDownItem hashLink={`${baseUrl}trad-${phaseNr}`} label="Traditionell schakt" indent={multiPhase} key={60} onClick={toggleDropDown} />);
            
            if(this.optionManager.isInsertionFlexibleLiningUsed(phaseState.techniquesToCompare)) {
                phaseNavs.push(<CalcDropDownItem hashLink={`${baseUrl}iff-${phaseNr}`} label="Infodring flexibla foder" indent={multiPhase} key={70} onClick={toggleDropDown} />);
            }
            if(this.optionManager.isTubeCrackingUsed(phaseState.techniquesToCompare)) {
                phaseNavs.push(<CalcDropDownItem hashLink={`${baseUrl}tc-${phaseNr}`} label="Rörspräckning" indent={multiPhase} key={80} onClick={toggleDropDown} />);
            }
            if(this.optionManager.isDirectedDrillingUsed(phaseState.techniquesToCompare)) {
                phaseNavs.push(<CalcDropDownItem hashLink={`${baseUrl}dd-${phaseNr}`} label="Styrd borrning" indent={multiPhase} key={90} onClick={toggleDropDown} />);
            }
            if(this.optionManager.isSlipliningUsed(phaseState.techniquesToCompare)) {
                phaseNavs.push(<CalcDropDownItem hashLink={`${baseUrl}sl-${phaseNr}`} label="Sliplining" indent={multiPhase} key={100} onClick={toggleDropDown} />);
            }
            if(this.optionManager.isPuLiningUsed(phaseState.techniquesToCompare)) {
                phaseNavs.push(<CalcDropDownItem hashLink={`${baseUrl}pul-${phaseNr}`} label="PU liner" indent={multiPhase} key={110} onClick={toggleDropDown} />);
            }
        }
        return phaseNavs;
    }
    
    render() {
        
        let multiPhase = this.props.projectUiInput.phaseStates.length > 1;
        
        const isAdminEmail = (email) => config.adminEmails.indexOf(email) !== -1;
        
        // Create calculation menu with or without navigation
        let calcMenu = (<LinkContainer to={'/calculation'}>
            <NavItem>
                <NavLink href="/calculation">Beräkning</NavLink>
            </NavItem>
        </LinkContainer>);

        let baseUrl = '/calculation#';

        if(this.props.projectUiInput.phaseStates.length > 1 || this.props.projectUiInput.phaseStates[0].techniquesToCompare !== -1) {
            let toggleDropDown = this.toggleCalcDropDown.bind(this);
            calcMenu = (<div>
                <Dropdown nav inNavbar isOpen={this.state.calcDropDownIsOpen} toggle={toggleDropDown}>
                    <DropdownToggle nav caret>
                        Beräkning
                    </DropdownToggle>
                    <DropdownMenu>
                        <CalcDropDownItem hashLink={`${baseUrl}project-info`} label="Projektinfo" indent={false} onClick={toggleDropDown} />

                        { this.props.projectUiInput.phaseStates.map((phaseState, phaseIdx) => this.createPhaseNavs(phaseState, phaseIdx + 1, multiPhase)) }
                        
                        { this.props.calcResult && [
                            <DropdownItem key="1" divider />,
                            <CalcDropDownItem key="2" hashLink={`/result`} label="Resultat" indent={false} onClick={toggleDropDown} />
                        ] }
                    </DropdownMenu>
                </Dropdown>
            </div>);
            
        }
        
        
        
        return (    
            <Navbar color="light" light expand="lg">
                <NavbarBrand href="/">
                    <img src="/images/logo-pollex-white.png" height="40"
                         className="d-inline-block align-top" alt="Pollex logo"/>
                    <span className="d-lg-none">Klimatkalkylator</span>
                     
                </NavbarBrand>
                <NavbarToggler onClick={this.toggleNavBar.bind(this)} className="navbar-dark"/>
                <Collapse isOpen={this.state.navBarIsOpen} navbar>
                    <Nav className="mr-auto" pills>
                        { this.props.userAuths && calcMenu }
                        { this.props.userAuths &&
                            <LinkContainer to={'/projects'} exact>
                                <NavItem>
                                    <NavLink href="/projects">Projekt</NavLink>
                                </NavItem>
                            </LinkContainer>
                        }
                        { !this.props.userAuths &&
                            <LinkContainer to={'/login'} exact>
                                <NavItem>
                                    <NavLink href="/login">Logga in</NavLink>
                                </NavItem>
                            </LinkContainer>
                        }
                        { this.props.userAuths && isAdminEmail(this.props.personEmail) &&
                            <LinkContainer to={'/admin'} exact>
                                <NavItem>
                                    <NavLink href="/admin">Admin</NavLink>
                                </NavItem>
                            </LinkContainer>
                        }
                        { this.props.userAuths &&
                            <LinkContainer to={'/logout'} exact>
                                <NavItem>
                                    <NavLink href="/logout">Logga ut</NavLink>
                                </NavItem>
                            </LinkContainer>
                        }
                    </Nav>
                    <Nav className="d-none d-lg-block" navbar>
                        <div className="demo-block">
                            <span className="product-name">
                                Pollex Klimatkalkylator&nbsp;
                            </span>
                            <span className="navbar-text">
                              <small>Version {this.props.projectUiInput.version}</small> 
                                {/*<span className="badge badge-danger">DEMO</span>*/}
                            </span>
                        </div>
                    </Nav>
                </Collapse>
            </Navbar>
        );
    }

};

export default ReactAI.withTracking(connect(
    state => state.calculation,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(NavMenu));




// WEBPACK FOOTER //
// ./src/components/NavMenu.js